import React, {useEffect, useMemo, useState} from "react";
import classnames from "classnames";
import LazyImage from "../../lazy-image";
import LazySvg from "../../lazy-svg";
import {Box, Tooltip} from "@mui/material";
import useIndustry from "../../../../hooks/use-industry";
import UIUtils from "../../../../utils";

const TagChipsContent = ({tag, useRepeatCount = false, useIcon = false, industryId = undefined}) => {
    const fileName = useMemo(() => tag?.iconFileName ?? tag?.iconInfo?.url, [tag]);
    const [errored, setErrored] = useState(false);
    const {industries} = useIndustry({noCategories: true})

    const industry = useMemo(() => industries.find(industry => industry.id === (tag?.industryId ?? industryId)), [industries, industryId, tag?.industryId]);

    /**
     * WIth each change in the filename of the icon.
     * - sets the errored state value to [false] to allow the icon to load.
     */
    useEffect(() => {
        setErrored(false);
    }, [fileName])

    return (
        <div className={classnames('tag-chips-content')}>
            {
                !!industry && industries.length > 1 &&
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 1,
                    color: 'primary.main',
                    marginRight: 1,
                }}>
                    {
                        React.cloneElement(UIUtils.getIndustryIcon(industry?.iconFileName, industry?.id, true) ??
                            <div/>, {style: {width: 20, height: 20, color: 'inherit'}})
                    }
                </Box>
            }
            {
                useRepeatCount &&
                <div className={'repeat-count'}>
                    {tag?.repeatCount}
                </div>
            }
            {
                useIcon && !!fileName && !errored &&
                <div className={'tag-icon-container'}>
                    {
                        fileName?.toLowerCase()?.endsWith('.png')
                            ? <LazyImage
                                src={fileName}
                                height={20}
                                width={20}
                                onError={() => setErrored(true)}
                            />
                            : <LazySvg
                                src={fileName}
                                height={20}
                                width={20}
                                onError={() => setErrored(true)}
                            />
                    }
                </div>
            }
            <Tooltip arrow placement={'bottom'} title={tag?.name ?? ''}>
                <p>
                    {tag.name ?? ''}
                </p>
            </Tooltip>

        </div>
    )
}

export default TagChipsContent;
